/**
=========================================================
* Material Dashboard 2 PRO React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from 'prop-types';

// @mui material components
import Card from '@mui/material/Card';
import Divider from '@mui/material/Divider';
import Icon from '@mui/material/Icon';

// Material Dashboard 2 PRO React components
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import MDButton from 'components/MDButton';

function StatisticCard({ color, title, count, icon, callback }) {
  return (
    <Card>
      <MDBox display='flex' justifyContent='space-between' pt={1} px={2}>
        <MDBox
          variant='gradient'
          bgColor={count > 0 ? 'error' : color}
          color={count > 0 ? 'white' : 'secondary'}
          coloredShadow={color}
          borderRadius='xl'
          display='flex'
          justifyContent='center'
          alignItems='center'
          width='4rem'
          height='4rem'
          mt={-3}
        >
          <Icon fontSize='medium' color='inherit'>
            {icon}
          </Icon>
        </MDBox>
        <MDBox textAlign='right' lineHeight={1.25}>
          <MDTypography variant='button' fontWeight='light' color='text'>
            {title}
          </MDTypography>
          <MDTypography variant='h4' color={count > 0 ? 'error' : 'secondary'}>
            {count}
          </MDTypography>
        </MDBox>
      </MDBox>
      <Divider />
      <MDBox pb={2}>
        {count > 0 ? (
          <MDButton
            fullWidth
            color='error'
            variant='text'
            sx={{ p: 0, fontSize: '1rem' }}
            onClick={callback}
          >
            <i className='fas fa-bell-on' /> &nbsp; ตรวจสอบข้อมูล
          </MDButton>
        ) : (
          <MDButton
            fullWidth
            variant='text'
            color='secondary'
            sx={{ p: 0, fontSize: '1rem', fontWeight: 100, color: '#cccccc' }}
          >
            <i className='fad fa-bell-slash' /> &nbsp; ไม่มีการแจ้งเตือน
          </MDButton>
        )}
      </MDBox>
    </Card>
  );
}

// Setting default values for the props of ComplexStatisticsCard
StatisticCard.defaultProps = {
  color: 'info',
};

// Typechecking props for the ComplexStatisticsCard
StatisticCard.propTypes = {
  color: PropTypes.oneOf([
    'primary',
    'secondary',
    'info',
    'success',
    'warning',
    'error',
    'light',
    'dark',
  ]),
  title: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  icon: PropTypes.node.isRequired,
  callback: PropTypes.func.isRequired,
};

export default StatisticCard;
